module.exports = __webpack_public_path__ + "img/5-4.2fcf9a5e.svg";